"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var lodash_1 = require("lodash");
var BaseService_1 = __importDefault(require("../../Core/BaseService"));
var SERVICE_NAME = 'reports-service';
exports.Routes = {
    GENERATE_REPORT: "/".concat(SERVICE_NAME, "/v1/report"),
    GET_LAYOUT: "/".concat(SERVICE_NAME, "/v1/layout"),
    GET_REPORT: "/".concat(SERVICE_NAME, "/v2/report"),
    GET_FILTERS: "/".concat(SERVICE_NAME, "/v2/filters"),
    GET_REPORT_EXECUTION: "/".concat(SERVICE_NAME, "/v1/report_execution"),
    GET_LAST_UPDATE_TIME: "/".concat(SERVICE_NAME, "/v1/last_update_time"),
    GET_CONFIGURATIONS: "/".concat(SERVICE_NAME, "/v1/configurations"),
    GET_CONFIGURATIONS_CSV: "/".concat(SERVICE_NAME, "/v1/configurations/report-download"),
    GET_CONFIGURATIONS_FILTER_OPTOINS: "/".concat(SERVICE_NAME, "/v1/configurations/filter-options")
};
var ReportsService = /** @class */ (function (_super) {
    __extends(ReportsService, _super);
    function ReportsService(session) {
        return _super.call(this, session, 'reports') || this;
    }
    ReportsService.prototype.getConfigurations = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, query;
            return __generator(this, function (_a) {
                payload = (0, lodash_1.pick)(options, ['changedBy', 'changedByAdmin', 'configurationModels', 'changeTime']);
                query = (0, lodash_1.pick)(options, ['limit', 'offset', 'sort']);
                return [2 /*return*/, this.routeGenerator
                        .post(exports.Routes.GET_CONFIGURATIONS)
                        .withPayload(payload)
                        .withQueryString(query)
                        .invoke()];
            });
        });
    };
    ReportsService.prototype.downloadConfigurations = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, query;
            return __generator(this, function (_a) {
                payload = (0, lodash_1.pick)(options, ['changedBy', 'changedByAdmin', 'configurationModels', 'changeTime']);
                query = (0, lodash_1.pick)(options, ['limit', 'offset', 'sort']);
                return [2 /*return*/, this.routeGenerator
                        .post(exports.Routes.GET_CONFIGURATIONS_CSV)
                        .withPayload(payload)
                        .withQueryString(query)
                        .invoke()];
            });
        });
    };
    ReportsService.prototype.getConfigurationsFilterOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator
                        .get(exports.Routes.GET_CONFIGURATIONS_FILTER_OPTOINS)
                        .invoke()];
            });
        });
    };
    ReportsService.prototype.getReportExecution = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeGenerator
                            .get(exports.Routes.GET_REPORT_EXECUTION)
                            .withQueryString({ uuid: uuid })
                            .invoke()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.url];
                }
            });
        });
    };
    ReportsService.prototype.getLastUpdateTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeGenerator
                            .get(exports.Routes.GET_LAST_UPDATE_TIME)
                            .invoke()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.last_update_time];
                }
            });
        });
    };
    ReportsService.prototype.getLayout = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (request) {
                            payload = JSON.stringify(request);
                            return [2 /*return*/, this.routeGenerator.get(exports.Routes.GET_LAYOUT).withQueryString({ payload: payload }).invoke()];
                        }
                        return [4 /*yield*/, this.routeGenerator.get(exports.Routes.GET_LAYOUT).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ReportsService.prototype.getReport = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = JSON.stringify(__assign({ widget_id: id }, options));
                        return [4 /*yield*/, this.routeGenerator
                                .get(exports.Routes.GET_REPORT)
                                .withQueryString({ payload: payload })
                                .invoke()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.report];
                }
            });
        });
    };
    ReportsService.prototype.getFilters = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = JSON.stringify(__assign({}, options));
                        return [4 /*yield*/, this.routeGenerator.get(exports.Routes.GET_FILTERS).withQueryString({ payload: payload }).invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ReportsService.prototype.cacheablesGetReport = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = JSON.stringify(__assign({ widget_id: id }, options));
                        return [4 /*yield*/, this.routeGenerator
                                .get(exports.Routes.GENERATE_REPORT)
                                .withQueryString({ payload: payload })
                                .invoke()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.report];
                }
            });
        });
    };
    return ReportsService;
}(BaseService_1.default));
exports.default = ReportsService;
//# sourceMappingURL=reports.service.js.map